var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"message",class:_vm.combindedClass},[_c('div',{staticClass:"message-body"},[_vm._v(" "+_vm._s(_vm.message)+" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }